import React, { useState, useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { PageTitleWithToolTip } from '../Common';
import { trakrefBlue } from '../../color_utils';
import { trakrefFontFamily } from '../../utils';
import Text from "../../Utils/Util_Components/Translator";
import Routes from '../../routes';
import EPA30Day from './EPA30Day';
import ChronicallyLeaky from './ChronicallyLeaky';
import EPALeakRateTrigger from './EpaLeakRateTrigger';
import LeakDetector350Days from './LeakDetector350Days';
import YearlyLeakInspectionViolations from './YearlyLeakInspectionViolations';

import './CriticalIssues.css';

const titleProps = {
    color: trakrefBlue,
    fontSize: "15px",
    sx: { fontWeight: 600 },
    tooltipMarginLeft: "0%"
};

const accordionSX = {
    boxShadow: "none",
    borderRadius: "3.52px",
    border: "0.88px solid #EBEDF8",
    background: "#FFF",
    position: 'static',
    "&:not(.Mui-expanded):hover": {
        backgroundColor: "rgba(235, 237, 248, 0.20)"
    },
}

const accordionSummarySX = {
    paddingLeft: "40px",
    "& .MuiAccordionSummary-content": {
        margin: "0px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
        margin: "0px",
    },
}

const accordionTitle = {
    color: "#008299",
    fontFamily: trakrefFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    textTransform: "uppercase"
}

const CriticalIssues = ({ }) => {
    const [potentialModel, setPotentialModel] = useState({});
    const [chronicallyLeakyClicked, setChronicallyLeakyClicked] = useState(false);
    const [ePA30DayClicked, setEPA30DayClicked] = useState(false);
    const [epaLeakRateTriggerClicked, setEpaLeakRateTriggerClicked] = useState(false);
    const [followUpVerificationViolationsClicked, setFollowUpVerificationViolationsClicked] = useState(false);
    const [leakDetector350DaysClicked, setLeakDetector350DaysClicked] = useState(false);
    const [yearlyLeakInspectionViolationsClicked, setYearlyLeakInspectionViolationsClicked] = useState(false);



    useEffect(() => {
        const fetchPotentialViolations = async () => {
            const potentials = await fetch(Routes.Dashboard.GetPotentialViolations());
            const potentialData = await potentials.json();
            setPotentialModel({ ...potentialData });
        };

        fetchPotentialViolations();
    }, []);

    return (
        <>
            <Typography sx={{
                color: "#1A173B",
                fontFamily: trakrefFontFamily,
                fontSize: "18.48px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
                letterSpacing: "0.127px",
                margin: "20px 0px 20px 40px",
            }}>
                Critical Issues
            </Typography>

            <Stack spacing={1.5}>
                <Accordion
                    expanded={leakDetector350DaysClicked}
                    onChange={() => setLeakDetector350DaysClicked(prev => !prev)}
                    sx={accordionSX}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="leakDetector350Days-content"
                        id="leakDetector350Days-header"
                        sx={accordionSummarySX}
                    >
                        <PageTitleWithToolTip
                            {...titleProps}
                            pageTitle={
                                <>
                                    ALDS WITHOUT CALIBRATION SERVICE FOR MORE THAN 350 DAYS <span style={{ color: "#44474A" }}>({potentialModel.violationLeakDetectors350Days ? (potentialModel.violationLeakDetectors350Days) : ""})</span>
                                </>
                            }
                            toolTipText="Review Leak Monitoring Devices (ALDS) that do not have a record of a Leak Monitor Calibration with a service date for more than 350 days."
                        />
                    </AccordionSummary>
                    <AccordionDetails AccordionDetails sx={{
                        padding: "0px"
                    }}>
                        <LeakDetector350Days />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={ePA30DayClicked}
                    onChange={() => setEPA30DayClicked(prev => !prev)}
                    sx={accordionSX}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="epa30Day-content"
                        id="epa30Day-header"
                        sx={accordionSummarySX}
                    >
                        <PageTitleWithToolTip
                            {...titleProps}
                            pageTitle={
                                <>
                                    EPA 30 DAY LEAK REPAIR DEADLINE <span style={{ color: "#44474A" }}>({potentialModel.epa30Day ? (potentialModel.epa30Day) : ""})</span>
                                </>
                            }
                            toolTipText={"View active assets with a charge of at least 15 lbs that have been Under Repair for more than 30 days."}
                        />
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: "0px"
                    }}>
                        <EPA30Day />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={yearlyLeakInspectionViolationsClicked}
                    onChange={() => setYearlyLeakInspectionViolationsClicked(prev => !prev)}
                    sx={accordionSX}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="yearlyLeakInspectionViolations-content"
                        id="yearlyLeakInspectionViolations-header"
                        sx={accordionSummarySX}
                    >
                        <PageTitleWithToolTip
                            {...titleProps}
                            pageTitle={
                                <>
                                    YEARLY LEAK INSPECTION DUE <span style={{ color: "#44474A" }}>({potentialModel.yearlyLeakInspectionViolations ? (potentialModel.yearlyLeakInspectionViolations) : ""})</span>
                                </>
                            }
                            toolTipText={"Review and schedule leak inspections for assets requiring an annual inspection."}
                        />
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: "0px"
                    }}>
                        <YearlyLeakInspectionViolations />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={epaLeakRateTriggerClicked}
                    onChange={() => setEpaLeakRateTriggerClicked(prev => !prev)}
                    sx={accordionSX}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="epaLeakRateTrigger-content"
                        id="epaLeakRateTrigger-header"
                        sx={accordionSummarySX}
                    >
                        <PageTitleWithToolTip
                            {...titleProps}
                            pageTitle={
                                <>
                                    EPA LEAK RATE TRIGGER RATE % EXCEEDED (SETTING FROM APPLIANCE) <span style={{ color: "#44474A" }}>({potentialModel.epaLeakRateTrigger ? potentialModel.epaLeakRateTrigger : ""})</span>
                                </>
                            }
                            toolTipNode={
                                <>
                                    <span>
                                        The EPA leak rate trigger rate % exceeded table under the Compliance Center provides owners a snapshot of systems with a capacity of 50 lbs or more of any refrigerant type,
                                        that exceed the EPA leak rate for the appliance type. Appliance Type trigger rates under Section 608 are:
                                    </span>
                                    <ul>
                                        <li>Industrial process refrigeration (Process Cooling) - 30%</li>
                                        <li>Commercial refrigeration (Refrigeration) - 20%</li>
                                        <li>Comfort Cooling - 10%</li>
                                    </ul>
                                    <span>
                                        The EPA leak rate calculation used is the calculation type within Trakref that is referred to as the EPA Method 1 Annualized - Since Last Service Event.
                                    </span>
                                </>
                            }
                        />
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: "0px"
                    }}>
                        <EPALeakRateTrigger />
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={chronicallyLeakyClicked}
                    onChange={() => setChronicallyLeakyClicked(prev => !prev)}
                    sx={accordionSX}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="chronicallyLeaky-content"
                        id="chronicallyLeaky-header"
                        sx={accordionSummarySX}
                    >
                        <PageTitleWithToolTip
                            {...titleProps}
                            pageTitle={
                                <>
                                    CHRONICALLY LEAKING SYSTEMS <span style={{ color: "#44474A" }}>({potentialModel.chronicLeakyViolations ? potentialModel.chronicLeakyViolations : ""})</span>
                                </>
                            }
                            toolTipText={"View assets with a charge of at least 15 lbs that leaked 125% or more during the current calendar year."}
                        />
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: "0px"
                    }}>
                        <ChronicallyLeaky />
                    </AccordionDetails>
                </Accordion>
            </Stack>
        </>
    );
};

export default CriticalIssues;